import { size } from "lodash";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import { Locale } from "@linkfluence/models/locale";
import {
  Role,
  canManageProject,
  canWriteOnProject,
} from "@linkfluence/models/role";
import { useContextualProjectUserRole } from "@radarly/core/context/use-cases";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { tr } from "@radarly/i18n";
import { Project } from "@radarly/models/project";
import { IRouterService } from "@radarly/shared/router";

function getFeatures(
  router: IRouterService,
  project: Project,
  role: Role,
  locale: Locale,
  panoramas: any,
  socialAccountsErrors: boolean,
  readOnly: boolean
) {
  if (readOnly || (project && !project.flags.isActive)) {
    return [];
  }
  const buttons = [];
  buttons.push({
    id: "report",
    label: tr(locale, "MAIN_MENU.REPORT_BUILDER"),
    icon: "slideshow",
  });
  buttons.push({
    id: "panoramas",
    label: tr(locale, "MAIN_MENU.PRESS_REVIEWS"),
    icon: "sheets",
    count: size(panoramas),
  });
  if (canWriteOnProject(role)) {
    buttons.push({
      id: "blacklist",
      label: tr(locale, "MAIN_MENU.BLACKLIST"),
      icon: "user-off",
    });
    buttons.push({
      id: "trash",
      label: tr(locale, "MAIN_MENU.TRASH"),
      icon: "trash",
    });
    buttons.push({
      id: "influencers",
      label: tr(locale, "MAIN_MENU.INFLUENCERS"),
      icon: "user-tag",
    });
  }
  buttons.push({
    id: "milestones",
    label: tr(locale, "MAIN_MENU.MILESTONES"),
    icon: "pin",
  });
  if (project) {
    if (!canManageProject(role)) {
      buttons.push({
        id: "alerts",
        label: tr(locale, "MAIN_MENU.ALERTING"),
        icon: "circle-bang",
        url: router.getSettingsUrl(project),
      });
    } else {
      buttons.push({
        id: "settings",
        label: tr(locale, "MAIN_MENU.CONFIG"),
        icon: "cog",
        url: router.getSettingsUrl(project),
        error: socialAccountsErrors,
      });
    }
  }
  return buttons;
}

export function useNavbarFeatures(router: IRouterService) {
  const project = useCurrentProject();
  const role = useContextualProjectUserRole();
  const locale = useCurrentUserLocale();
  const socialAccountsErrors = false;
  const panoramas = [];
  const readOnly = false;
  const features = project.id
    ? getFeatures(
        router,
        project,
        role,
        locale,
        panoramas,
        socialAccountsErrors,
        readOnly
      )
    : [];
  return { features };
}
